import ModalService from "services/modal";

export const productTourModal = new ModalService("productTour");
